import React from 'react'

import AuthPanel from '../AuthPanel'

// Body swapped for the canonical lib-core auth panel (opens on the
// forgot-password form). The redux-form ForgotPasswordForm and the
// forgotPassword action wiring are superseded; the route
// ('home/welcome/login/forgot-password') is unchanged.
const ForgotPasswordPage = () => {
  return <AuthPanel initialState="forgot" />
}

export default ForgotPasswordPage
